// Point d'entrée : rendu conditionnel depuis config.js, préférences, chargement des modules de section.
//
// Attributs HTML reconnus :
//   data-bind="dates.firstShipping" data-format="date|price|int|text"
//       -> remplit le texte ; valeur null => placeholder visible [À CONFIRMER]
//   data-bind-optional -> avec data-bind : valeur null => l'élément est masqué au lieu du placeholder
//   data-href="links.legal" -> href du lien ; null => lien inactif + [À CONFIRMER]
//   data-show-if="gaugePercent|membersVisible|…"   (clé de `derived` ou chemin de config)
//       -> élément masqué (hidden) si la valeur est null/false. « !clé » inverse la condition.
import { config } from "./ma-js-config.js?v=9dbd173928";
import { get, isSet, derived, FORMATS, TBC, prefersReducedMotion, $$ } from "./ma-js-utils.js?v=9dbd173928";
import { initTracking } from "./ma-js-tracking.js?v=9dbd173928";
import { initFunnel } from "./ma-js-funnel.js?v=9dbd173928";

// Modules de section, chargés s'ils existent ; un module en échec ne casse pas la page.
const SECTIONS = ["urgency", "offer", "faq", "reveal", "flip", "audio", "why", "pictos", "spots", "lamp", "drop", "sticky", "carnet", "months"];

function resolve(key) {
  return key in derived ? derived[key] : get(key);
}

export function applyConditions(root = document) {
  $$("[data-show-if]", root).forEach((el) => {
    const raw = el.dataset.showIf.trim();
    const neg = raw.startsWith("!");
    const ok = isSet(resolve(neg ? raw.slice(1) : raw));
    el.hidden = neg ? ok : !ok;
  });
}

export function applyBindings(root = document) {
  $$("[data-bind]", root).forEach((el) => {
    const fmt = FORMATS[el.dataset.format || "text"] || FORMATS.text;
    const value = fmt(resolve(el.dataset.bind));
    if (value !== null) {
      el.textContent = value;
      el.classList.remove("ma-tbc");
    } else if (el.hasAttribute("data-bind-optional")) {
      el.hidden = true;
    } else {
      el.textContent = TBC;
      el.classList.add("ma-tbc");
    }
  });
}

// data-href="links.legal" -> href depuis la config ; null => lien inactif + [À CONFIRMER]
export function applyLinks(root = document) {
  $$("[data-href]", root).forEach((a) => {
    const url = resolve(a.dataset.href);
    if (isSet(url)) {
      a.href = url;
    } else {
      a.removeAttribute("href");
      a.setAttribute("aria-disabled", "true");
      if (!a.querySelector(".ma-tbc")) a.insertAdjacentHTML("beforeend", ` <span class="ma-tbc">${TBC}</span>`);
    }
  });
}

function applyPreferences() {
  const root = document.documentElement;
  const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
  const sync = () => root.classList.toggle("is-reduced-motion", mq.matches);
  sync();
  mq.addEventListener?.("change", sync);
  root.classList.add("js");
}

async function loadSections() {
  const ctx = { config, derived, reducedMotion: prefersReducedMotion() };
  await Promise.all(
    SECTIONS.map(async (name) => {
      try {
        const mod = await import(`./ma-js-sections-${name}.js?v=9dbd173928`);
        mod.init?.(ctx);
      } catch (err) {
        console.warn(`[MA] section « ${name} » non chargée :`, err);
      }
    })
  );
}

function boot() {
  applyPreferences();
  applyConditions();
  applyBindings();
  applyLinks();
  initTracking(config);
  initFunnel(config);
  loadSections();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
